export function base64ToBlob(base64, type = 'application/pdf') {
  const binary = atob(base64)
  const buf = new ArrayBuffer(binary.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i < binary.length; i++) {
    view[i] = binary.charCodeAt(i) & 0xff
  }
  return new Blob([buf], { type })
}

/* centralized func to download files from OKV */
export function downloadFile(
  instance,
  http,
  api,
  dataToSend,
  type,
  spinnerProperty,
  setFileName,
  msg,
  fnCallback,
  errorStr
) {
  instance[http](api, dataToSend ? dataToSend : null)
    .then((resp) => {
      /* spinnerProperty passed by parent component to start loading spinner during file download... */
      if (spinnerProperty) {
        instance[spinnerProperty] = true
      }

      if (resp.base64ByteArray == null) {
        alert(msg)
      }

      const blob = base64ToBlob(resp.base64ByteArray, type)

      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = resp.filename && resp.filename != null ? resp.filename : setFileName

      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(link.href)
    })
    .catch(() => alert(errorStr ? errorStr : 'Errore nella ricezione dei dati'))
    .finally(() => {
      spinnerProperty ? (instance[spinnerProperty] = false) : null
      if (fnCallback) fnCallback()
    })
}

export function convertFileToByteArray(file, type, callback) {
  var fileByteArray = []

  var reader = new FileReader() /* ASYNC */
  var blob = new Blob([file], { type: type })

  reader.readAsArrayBuffer(blob)

  reader.onload = (e) => {
    if (e.target.readyState == FileReader.DONE) {
      var arrayBuffer = e.target.result
      var array = new Uint8Array(arrayBuffer)
      for (let i = 0; i < array.length; i++) {
        fileByteArray.push(array[i])
      }
      return callback(fileByteArray)
    }
  }
}
